"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = _interopRequireDefault(require("immutable"));

var _default = _immutable.default.Map({
  'application/vnd.google-apps.document': '.docx',
  'application/vnd.google-apps.kix': '.docx',
  'application/vnd.google-apps.presentation': '.pptx',
  'application/vnd.google-apps.punch': '.pptx',
  'application/vnd.google-apps.spreadsheet': '.xlsx',
  'application/vnd.google-apps.ritz': '.xlsx'
});

exports.default = _default;
module.exports = exports.default;